import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../shared/shared.module';
import { AffectedOperationsPage } from './affected-operations';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    AffectedOperationsPage
  ],
  imports: [
    IonicPageModule.forChild(AffectedOperationsPage),
    SharedModule,
    FoundationModule,
    DirectivesModule,
  ],
})
export class AffectedOperationsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/affected-operations/affected-operations.module.ts